import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setMessageHandler } from "../../reducers/selectedValues";
import Box from "@mui/material/Box";
import { RoleConfig } from "../admin/roles/roleConfig";
import { UserConfig } from "../admin/users/userConfig";
import { FacilitySettings } from "../admin/facilitySettings/facilitySettings";
import { FunctionalAreaConfig } from "../admin/functionalArea/functionalAreaConfig";
import { Typography } from "@mui/material";
import { TimezoneConfig } from "../admin/timezones/timezoneConfig";
import { DstYearConfig } from "../admin/dstYears/dstYearConfig";
import { SiteStandardConfig } from "../users/siteStandards/siteStandardConfig";
import { ColumnLookupConfig } from "../admin/columnLookup/columnLookupConfig";
import { FileTypeConfig } from "../admin/fileTypes/fileTypeConfig";
import { DataSourceConfig } from "../admin/dataSources/dataSourceConfig";
import { DataImport } from "../users/dataImport/dataImport";
import { ImportStatus } from "../users/importStatus/importStatus";
import { ExternalReports } from "../users/reports/externalReports";
import { MissingDataReasons } from "../users/missingDataReasons/missingDataReasons";

export const FlowWorkspace = (props) => {
  const activeMenu = useSelector(
    (state) => state.SelectedValues.activeComponent
  );

  const messageDispatch = useDispatch();
  useEffect(() => {
    messageDispatch(setMessageHandler({ type: null, message: null }));
  }, [activeMenu]);

  const workSpaceWidth = props.open ? "calc(100vw - 265px)" : "calc(97vw)";
  return (
    <Box
      sx={{
        p: 3,
        overflow: "none",
        width: workSpaceWidth,
      }}
    >
      <Box
        sx={{
          pt: 0,
          overflow: "auto",
          width: workSpaceWidth,
          height: "calc(100vh - 110px)",
        }}
      >
        {activeMenu === "" && (
          <Typography paragraph>
            {activeMenu} ------ page under development
          </Typography>
        )}
        {activeMenu?.toLowerCase() === "users" && <UserConfig />}
        {activeMenu?.toLowerCase() === "roles" && <RoleConfig />}
        {activeMenu?.toLowerCase() === "facilities" && <FacilitySettings />}
        {activeMenu?.toLowerCase() === "functional areas" && (
          <FunctionalAreaConfig />
        )}
        {activeMenu?.toLowerCase() === "timezones" && <TimezoneConfig />}
        {activeMenu?.toLowerCase() === "dst years" && <DstYearConfig />}
        {activeMenu?.toLowerCase() === "site standards" && (
          <SiteStandardConfig />
        )}
        {activeMenu?.toLowerCase() === "column names" && <ColumnLookupConfig />}
        {activeMenu?.toLowerCase() === "file types" && <FileTypeConfig />}
        {activeMenu?.toLowerCase() === "data sources" && <DataSourceConfig />}
        {activeMenu?.toLowerCase() === "import data" && <DataImport />}
        {activeMenu?.toLowerCase() === "import status" && <ImportStatus />}
        {activeMenu?.toLowerCase() === "reports" && <ExternalReports />}
        {activeMenu?.toLowerCase() === "missing data reasons" && (
          <MissingDataReasons />
        )}
      </Box>
    </Box>
  );
};
